import { TIMEZONE_OPTIONS } from 'constants/index';

import { Offer } from '../slice';

// Goal limits constants
export const GOAL_LIMITS = {
  MIN_GOALS: 1,
} as const;

// Helper function to create a default goal
export const createDefaultGoal = () => ({
  goalid: 0,
  goalcompletionorder: 0,
  pointsawarded: undefined,
  status: 'insert',
  isconversioncapactive: false,
  conversiontimerange: undefined,
  conversioncapvalue: undefined,
  currentconversionvalue: undefined,
  goalcompletioninstructions: undefined,
  ispointschangescheduled: false,
  pointschangetype: null,
  pointschangestartdate: null,
  pointschangestartvalue: null,
  pointschangeenddate: null,
  pointschangeendvalue: null,
  pointschangestimezone: TIMEZONE_OPTIONS[0].value,
});

// Helper function to ensure at least one goal exists
export const addDefaultGoal = (offer: Offer) => {
  if (
    !offer.offertunegoals ||
    offer.offertunegoals.length === 0 ||
    offer.offertunegoals.every((goal) => goal.status === 'delete')
  ) {
    return {
      ...offer,
      offertunegoals: [createDefaultGoal()],
    };
  }
  return offer;
};
